import { useCallback, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { accordionStyle, accordionSummaryStyle, titleStyle } from './styles';

type OverviewAccordionProps = {
  title: string;
  details: React.ReactNode;
  defaultExpanded: boolean;
  customStyle?: SxProps;
};

export const OverviewAccordion = ({
  title,
  details,
  defaultExpanded = false,
  customStyle = {},
}: OverviewAccordionProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(defaultExpanded);

  const handleChange = useCallback((event: React.SyntheticEvent, expanded: boolean) => {
    setIsExpanded(expanded);
  }, []);

  return (
    <Accordion
      disableGutters
      elevation={0}
      expanded={isExpanded}
      onChange={handleChange}
      sx={{ ...accordionStyle, ...customStyle }}
      id={title}
    >
      <AccordionSummary
        sx={accordionSummaryStyle}
        expandIcon={<ExpandMoreIcon sx={{ padding: '0.4rem' }} />}
      >
        <Typography variant="h6" sx={titleStyle}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ minHeight: '200px' }}>{details}</AccordionDetails>
    </Accordion>
  );
};
